/**
 * 监听页面显示是否是通过缓存显示的
 * 这个场景可能发生在移动端用户通过"返回键"回到上一个页面并浏览器采取了 "bfcache" 导致命中缓存
 * @param {Function} callback - 当命中缓存且页面展示时回调
 * @param {object} [options] - addEventListener options 参数
 * @return {function(): void}
 */
export default function onPageShowByCache(callback, options) {
  const eventType = 'pageshow';
  const listener = e => {
    if (e.persisted) {
      callback();
    }
  };
  window.addEventListener(eventType, listener, options);
  return () => window.removeEventListener(eventType, listener, options);
}
